import { FC, useEffect } from 'react';
import gtmParts, { IGTMConfig } from 'react-google-tag-manager';

const GoogleTagManager: FC<IGTMConfig> = ({
    dataLayerName = 'dataLayer',
    scriptId = 'react-google-tag-manager-gtm',
    gtmId,
    additionalEvents = {},
    previewVariables = false,
}) => {
    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-member-access
        if (!(window as any)[dataLayerName]) {
            const gtmScriptNode = document.getElementById(scriptId);

            eval(gtmScriptNode?.textContent as string);
        }
    }, []);
    /* eslint-enable react-hooks/exhaustive-deps */

    if (gtmId) {
        const gtm = gtmParts({ id: gtmId, dataLayerName, additionalEvents, previewVariables });

        return (
            <div>
                <div>{gtm.noScriptAsReact()}</div>
                <div id={scriptId}>{gtm.scriptAsReact()}</div>
            </div>
        );
    }

    return null;
};

export default GoogleTagManager;
